import { render, staticRenderFns } from "./kcsftj.vue?vue&type=template&id=4bb11654&"
import script from "./kcsftj.vue?vue&type=script&lang=js&"
export * from "./kcsftj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports